import { useEffect } from 'react';
import { Package } from 'lucide-react';
import PriceSearchPanel from '@/components/PriceSearchPanel';

export default function Fournisseurs() {
  useEffect(() => { document.title = 'Fournisseurs · Reno Resolve'; }, []);

  return (
    <div className="space-y-4 md:space-y-6" data-testid="fournisseurs-page">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center shrink-0">
          <Package className="w-5 h-5 text-blue-700" />
        </div>
        <div className="min-w-0 flex-1">
          <h1 className="text-xl md:text-3xl font-bold text-slate-900 truncate" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Fournisseurs
          </h1>
          <p className="text-xs md:text-sm text-slate-500">
            Recherche de prix matériaux TTC · image, référence, lien direct
          </p>
        </div>
      </div>

      <PriceSearchPanel />
    </div>
  );
}
